import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Gallery } from "@/components/Gallery";
import { Amenities } from "@/components/Amenities";
import { UseCases } from "@/components/UseCases";
import { Pricing } from "@/components/Pricing";
import { Location } from "@/components/Location";
import { Faq } from "@/components/Faq";
import { BookingForm } from "@/components/BookingForm";
import { Partners } from "@/components/Partners";
import { Footer } from "@/components/Footer";
import { SectionHeading } from "@/components/SectionHeading";

const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`py-20 sm:py-28 lg:py-32 ${className}`}>
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">{children}</div>
  </section>
);

function App() {
  return (
    <div className="App bg-[#F7F4EE]">
      <Nav />
      <main>
        <Hero />

        <Section id="tila">
          <SectionHeading
            accent="tervetuloa sisään"
            title="Tila ja varustelu"
            intro="Hengähdys on noin 95 m² kokonaisuus Porvoon Pappilanmäellä: 60 m² juhlatila sekä sauna noin 10 hengelle. Tilassa on kaikki valmiina pieniin juhliin, kokouksiin ja saunailtoihin."
          />
          <div className="mt-14">
            <Gallery />
          </div>
          <div className="mt-16 lg:mt-20">
            <Amenities />
          </div>
        </Section>

        <Section id="kayttotarkoitukset" className="bg-[#8A9B87]/8">
          <SectionHeading accent="mihin tila sopii" title="Käyttötarkoitukset" />
          <div className="mt-14">
            <UseCases />
          </div>
        </Section>

        <Section id="hinnasto">
          <SectionHeading
            accent="selkeät hinnat"
            title="Hinnasto"
            intro="Valitse illaksi, päiväksi tai koko viikonlopuksi."
          />
          <div className="mt-14">
            <Pricing />
          </div>
        </Section>

        <Section id="sijainti" className="bg-[#A9805B]/6">
          <Location />
        </Section>

        <Section id="ukk">
          <SectionHeading
            accent="hyvä tietää"
            title="Usein kysytyt kysymykset"
            align="center"
          />
          <div className="mt-14">
            <Faq />
          </div>
        </Section>

        <Section id="yhteistyo" className="bg-[#A9805B]/6">
          <SectionHeading
            accent="hyvässä seurassa"
            title="Yhteistyökumppanit"
            intro="Suosittelemme lämpimästi kumppaneitamme — yhdessä saat juhlistasi tai hyvinvointipäivästäsi vielä elämyksellisemmän."
          />
          <div className="mt-14">
            <Partners />
          </div>
        </Section>

        <Section id="varaus" className="bg-[#8A9B87]/8">
          <SectionHeading
            accent="otetaan yhteyttä"
            title="Varauskysely"
            intro="Kerro toiveesi, niin katsotaan vapaat ajat. Vastaamme yleensä saman päivän aikana."
            align="center"
          />
          <div className="mt-14">
            <BookingForm />
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
